/**
 * Money formatting shared by every script that writes a price into the page.
 *
 * Prices from Liquid and from the AJAX cart arrive as cents in the currency the
 * customer is browsing in (Shopify converts them), so the only thing scripts
 * have to get right is the symbol and grouping. Hardcoding "$" showed dollars
 * to shoppers whose checkout was in their own currency.
 *
 * Usage: window.formatMoney(9995)            -> "$99.95" / "₹99.95" / ...
 *        window.formatMoney(9995, 'INR')     -> force a currency
 */
(function () {
  'use strict';

  function activeCurrency() {
    // Shopify.currency.active is the currency the storefront is presenting in
    var shopify = window.Shopify;
    if (shopify && shopify.currency && shopify.currency.active) {
      return shopify.currency.active;
    }
    return 'USD';
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents);
    if (!isFinite(amount)) amount = 0;
    amount = amount / 100;

    var code = currency || activeCurrency();

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: code,
        // Shopify prices are whole cents; keep trailing zeros off whole amounts
        // only when the currency itself has no minor unit (JPY, KRW, ...)
        minimumFractionDigits: undefined,
      }).format(amount);
    } catch (e) {
      // Unknown currency code or very old browser
      return code + ' ' + amount.toFixed(2);
    }
  }

  window.formatMoney = formatMoney;
  window.activeCurrency = activeCurrency;
})();
